import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * Error screen for SessionManager and authentication errors
 */
export const SessionError = ({ message }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      width: '100%',
      backgroundColor: '#f7fafd',
      padding: '20px',
    }}
  >
    <Box
      sx={{
        maxWidth: '500px',
        width: '100%',
        backgroundColor: '#1e293b',
        border: '1px solid #334155',
        borderRadius: '12px',
        padding: '32px',
        textAlign: 'center',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)',
      }}
    >
      {/* Error icon */}
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fca5a5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>

      {/* Error title */}
      <Box
        component="h2"
        sx={{
          marginTop: '12px !important',
          fontSize: '24px',
          fontWeight: '700',
          color: '#f1f5f9',
          margin: '0 0 12px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        Error
      </Box>

      {/* Error message */}
      <Box
        component="p"
        sx={{
          fontSize: '16px',
          color: '#cbd5e1',
          margin: '0 0 24px',
          lineHeight: '1.6',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        {message || 'An unexpected error occurred. Please try refreshing the page.'}
      </Box>

      {/* Reload button */}
      <Box
        component="button"
        onClick={() => window.location.reload()}
        sx={{
          backgroundColor: '#EF4444',
          color: '#ffffff',
          border: 'none',
          borderRadius: '8px',
          padding: '12px 24px',
          fontSize: '16px',
          fontWeight: '600',
          cursor: 'pointer',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          transition: 'background-color 0.2s',
          '&:hover': {
            backgroundColor: '#DC2626',
          },
        }}
      >
        Reload Page
      </Box>
    </Box>
  </Box>
);

SessionError.propTypes = {
  message: PropTypes.string,
  error: PropTypes.object,
};
